export default function AvailablePacks() {
  return (
    <section className="section-padding bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Available Packs
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Each Harbor Agent pack provides a complete toolkit for preparing your team for specific initiatives
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto space-y-8">
          {/* Pack #1 - Genesis */}
          <div className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200 border border-gray-100">
            <div className="mb-6">
              <div className="inline-flex items-center px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-sm font-medium mb-4">
                Pack #1
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-3">
                Genesis Mission Readiness Pack (Pack #1)
              </h3>
              <p className="text-xl text-gray-600 mb-2">
                AI-native engineering toolkit for the DOE Genesis Mission.
              </p>
              <p className="text-lg font-semibold text-primary-600 mb-6">
                $199 • One-Time
              </p>
            </div>
            
            <div className="mb-6">
              <h4 className="text-lg font-semibold text-gray-900 mb-4">What's Included:</h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">✓</span>
                  <span>Readiness checklists</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">✓</span>
                  <span>Governance and documentation templates</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">✓</span>
                  <span>AI copilot playbooks (Cursor, GitHub Copilot, Claude Code, etc.)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">✓</span>
                  <span>Proposal and internal communication templates</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">✓</span>
                  <span>Automation and audit scripts</span>
                </li>
              </ul>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="/packs/genesis-mission#pricing"
                className="btn-primary text-lg px-8 py-4 text-center"
              >
                View Pack Details
              </a>
              <a
                href="https://github.com/gentlyventures/harboragent"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary text-lg px-8 py-4 text-center"
              >
                Free Tier on GitHub
              </a>
            </div>
          </div>

          {/* Pack #2 - Tax Assist */}
          <div className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200 border border-gray-100">
            <div className="mb-6">
              <div className="inline-flex items-center px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-sm font-medium mb-4">
                Pack #2
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-3">
                AI Tax Assistant Readiness Pack (Pack #2)
              </h3>
              <p className="text-xl text-gray-600 mb-2">
                2025 U.S. Tax Year readiness for Individual Tax Preparers.
              </p>
              <p className="text-lg font-semibold text-accent-600 mb-6">
                $199 • One-Time
              </p>
            </div>
            
            <div className="mb-6">
              <h4 className="text-lg font-semibold text-gray-900 mb-4">What's Included:</h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-accent-600 mr-2">✓</span>
                  <span>2025 tax year readiness checklists</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent-600 mr-2">✓</span>
                  <span>Form processing guides (Form 1099-DA, K-1s, etc.)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent-600 mr-2">✓</span>
                  <span>AI copilot playbooks for tax workflows</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent-600 mr-2">✓</span>
                  <span>Client communication templates</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent-600 mr-2">✓</span>
                  <span>Workflow automation scripts</span>
                </li>
              </ul>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="/packs/tax-assist#pricing"
                className="btn-primary text-lg px-8 py-4 text-center"
              >
                View Pack Details
              </a>
              <a
                href="https://github.com/gentlyventures/harboragent"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary text-lg px-8 py-4 text-center"
              >
                Free Tier on GitHub
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

